import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import { filterDataProps } from "../../utils/FilterDataProps.js";
import { HOVER, CLICK } from "./constants.js";
import { st, classes } from "./CoreDropdown.st.css";
import { CorePopover } from "../CorePopover/CorePopover.js";
import { CoreDropdownContent } from "../CoreDropdownContent/CoreDropdownContent.js";
class CoreDropdownComponent extends React.PureComponent {
  static displayName = "CoreDropdown";
  dropdownContentRef = null;
  constructor(props) {
    super(props);
    this.close = this.close.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.onPopoverClick = this.onPopoverClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onOptionHover = this.onOptionHover.bind(this);
    this.onOptionClick = this.onOptionClick.bind(this);
    this._onContentMouseDown = this._onContentMouseDown.bind(this);
  }
  state = { isOpen: false, selectedIds: [] };
  componentDidMount() {
    this.initializeSelectedOptions();
  }
  componentDidUpdate(prevProps) {
    if (!CoreDropdownComponent.areSelectedIdsEqual(
      this.props.initialSelectedIds,
      prevProps.initialSelectedIds
    )) {
      this.initializeSelectedOptions();
    }
  }
  static areSelectedIdsEqual = (selectedIds1, selectedIds2) => {
    if (selectedIds1 === void 0 && selectedIds2 === void 0 || selectedIds1 === null && selectedIds2 === null) {
      return true;
    }
    return Array.isArray(selectedIds1) && Array.isArray(selectedIds2) && selectedIds1.length === selectedIds2.length && selectedIds1.every((item, index) => item === selectedIds2[index]);
  };
  initializeSelectedOptions() {
    const { initialSelectedIds, options, onInitialSelectedOptionsSet } = this.props;
    const selectedOptions = (initialSelectedIds || []).map((id) => options.find((option) => id === option.id)).filter((option) => option && !option.isDisabled && option.isSelectable);
    const selectedIds = selectedOptions.map((x) => x && x.id);
    this.setState({
      selectedIds
    });
    onInitialSelectedOptionsSet && onInitialSelectedOptionsSet(selectedOptions);
  }
  handleClickOutside() {
    this.close();
  }
  _onExpandedChange() {
    if (this.props.onExpandedChange) {
      this.props.onExpandedChange(this.state.isOpen);
    }
  }
  open() {
    this.setState({ isOpen: true }, () => this._onExpandedChange());
  }
  onPopoverClick() {
    if (this.state.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }
  close() {
    if (this.state.isOpen) {
      this.setState({ isOpen: false }, this._onExpandedChange);
    }
  }
  getSelectedOption() {
    return this.dropdownContentRef ? this.dropdownContentRef.getSelectedOption() : null;
  }
  onKeyboardSelect() {
    const selectedOption = this.getSelectedOption();
    this.onOptionClick(selectedOption);
  }
  isClosingKey(key) {
    const { dropdownA11yFixes } = this.props;
    return key === "Tab" || key === "Escape" || !dropdownA11yFixes && key === "Enter";
  }
  onKeyDown(evt) {
    const eventKey = evt.key;
    const { dropdownA11yFixes } = this.props;
    if (this.state.isOpen) {
      const handleSelect = () => {
        this.onKeyboardSelect();
        !this.props.multi && this.close();
        if (this.getSelectedOption() !== null) {
          evt.preventDefault();
        }
      };
      switch (eventKey) {
        case "Tab":
        case "Enter": {
          handleSelect();
          if (dropdownA11yFixes) {
            evt.preventDefault();
          }
          break;
        }
        case "Escape": {
          this.close();
          break;
        }
      }
    } else {
      if (this.isClosingKey(eventKey)) {
        return;
      }
      if (dropdownA11yFixes) {
        if (eventKey === "Enter" || eventKey === " " || eventKey === "ArrowDown" || eventKey === "ArrowUp") {
          evt.preventDefault();
        } else if (/^.$/u.test(evt.key)) {
          this.open();
        } else {
          return;
        }
      }
      if (eventKey === "Unidentified") {
        return;
      }
      this.open();
    }
    this.dropdownContentRef && this.dropdownContentRef.onKeyDown(eventKey, evt);
  }
  _onContentMouseDown(e) {
    const { onContentMouseDown } = this.props;
    onContentMouseDown && onContentMouseDown(e);
  }
  onOptionHover(option) {
    if (this.props.onOptionHover) {
      this.props.onOptionHover(option);
    }
  }
  onOptionClick(option) {
    const { onSelect, onDeselect, multi, allowReselect } = this.props;
    const { selectedIds } = this.state;
    const newState = {
      isOpen: !!multi,
      selectedIds
    };
    let callback = onSelect;
    if (multi) {
      if (option) {
        if (selectedIds.includes(option.id)) {
          newState.selectedIds = selectedIds.filter((x) => x !== option.id);
          callback = onDeselect;
        } else {
          newState.selectedIds = [...selectedIds, option.id];
        }
      }
    } else if (option) {
      if (selectedIds.includes(option.id)) {
        this.close();
        if (!allowReselect) {
          return;
        }
      } else {
        newState.selectedIds = [option.id];
      }
    } else {
      newState.selectedIds = [];
    }
    this.setState(newState, () => callback(option));
  }
  render() {
    const {
      openTrigger,
      placement,
      options,
      children,
      showArrow,
      fixedFooter,
      fixedHeader,
      disabled,
      readOnly,
      timeout,
      forceContentElementVisibility,
      style: inlineStyles,
      id,
      flip,
      fixed,
      moveBy,
      role,
      contentId,
      optionsContainerZIndex,
      dynamicWidth,
      appendTo,
      className,
      contentClassName,
      focusOnOption,
      contentRole,
      eventsEnabled,
      noResultsText
    } = this.props;
    const { isOpen, selectedIds } = this.state;
    const hasContent = Boolean(
      options && options.length || fixedHeader || fixedFooter
    );
    const shown = forceContentElementVisibility || isOpen && !disabled && !readOnly && hasContent;
    return /* @__PURE__ */ jsxs(
      CorePopover,
      {
        className: st(classes.root, { "content-visible": shown }, className),
        contentClassName,
        placement,
        shown,
        showArrow,
        timeout,
        onClickOutside: this.handleClickOutside,
        onClick: !disabled && !readOnly && openTrigger === CLICK ? () => this.onPopoverClick() : void 0,
        onMouseEnter: !disabled && !readOnly && openTrigger === HOVER ? () => this.open() : void 0,
        onKeyDown: !disabled && !readOnly ? this.onKeyDown : void 0,
        onMouseLeave: !disabled && !readOnly && openTrigger === HOVER ? this.close : void 0,
        style: inlineStyles,
        id,
        flip,
        fixed,
        moveBy,
        role,
        zIndex: optionsContainerZIndex,
        dynamicWidth,
        appendTo,
        eventsEnabled,
        ...filterDataProps(this.props),
        children: [
          /* @__PURE__ */ jsx(CorePopover.Element, { children }),
          /* @__PURE__ */ jsx(CorePopover.Content, { children: /* @__PURE__ */ jsx(
            CoreDropdownContent,
            {
              className: classes.dropdownContent,
              role: contentRole,
              "data-hook": "dropdown-content",
              ref: (dropdownContent) => this.dropdownContentRef = dropdownContent,
              options,
              fixedFooter,
              fixedHeader,
              selectedIds,
              onOptionClick: this.onOptionClick,
              onOptionHover: this.onOptionHover,
              onMouseDown: this._onContentMouseDown,
              optionsContainerId: contentId,
              focusOnOption,
              noResultsText
            }
          ) })
        ]
      }
    );
  }
}
const CoreDropdown = CoreDropdownComponent;
export {
  CoreDropdown,
  CoreDropdownComponent
};
//# sourceMappingURL=CoreDropdown.js.map
